<template>
  <v-card class="mb-2">
    <v-card-title>
      <div class="d-flex align-center">
        <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('prmo')" color="white">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
        <h2>Результаты ПРМО</h2>
      </div>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="meta.total"
      @click:row="showItem"
    >
      <template v-slot:top></template>

      <template v-slot:item.date="{ item }">
        <div>{{ item.date }}</div>
        <div v-if="item.time">{{ item.time }}</div>
        <div v-if="item.who">{{ item.who }}</div>
      </template>

      <template v-slot:item.group="{}">
        1
      </template>

      <template v-slot:item.type="{}">
        Предсменный/предрейсовый
      </template>

      <template v-slot:item.result="{ item }">
        {{ item.result === 0 ? "Недопущен" : "Допущен" }}
      </template>
    </v-data-table>

    <!--<iframe
      class="inspection-iframe"
      v-if="isShow"
      :src="
        `${VUE_APP_V3_HOST}/inspections/journal?hash=${hash}&resultOnly=1&customerId=${customerId}&content-only=true&silent-notifications=1`
      "
      width="100%"
      height="500"
      allow-same-origin
      frameborder="0"
    ></iframe>-->
  </v-card>
</template>

<script>
import throttle from "lodash/throttle";
import DateRangePicker from "@/components/forms/DateRangePicker";
import { mapMutations, mapState } from "vuex";
import { CustomerService } from "@/services/api/customer.service";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";
import { FLAGS } from "@/configs";
import Loader from "@/components/Loader.vue";
import { VUE_APP_V3_HOST } from "@/config";

export default {
  name: "Inspections",
  components: { DateRangePicker, Loader },
  data: () => ({
    loading: true,
    VUE_APP_V3_HOST,
    options: {},
    filters: {
      type: "",
      system: "",
      date: [],
    },
    search: "",
    headers: [
      {
        text: "Дата и время",
        align: "start",
        sortable: false,
        value: "date",
      },
      {
        text: "Тип системы",
        align: "start",
        sortable: false,
        value: "system_name",
      },
      {
        text: "Тип осмотра",
        align: "start",
        sortable: false,
        value: "type_name",
      },
      {
        text: "Комментарий",
        align: "start",
        sortable: false,
        value: "comment",
      },
      {
        text: "Результат",
        align: "start",
        sortable: false,
        value: "result",
      },
      /*{
        text: "Причина",
        align: "start",
        sortable: false,
        value: "cause",
      },*/
    ],
    items: [],
    meta: {
      total: 0,
    },
    systemTypes: [],
    inspectionTypes: [],
  }),

  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("prmo");
    },
    customerId() {
      return this.$store.state.customer.id;
    },
    hash() {
      return this.$store.state.auth.accessToken;
    },
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  async mounted() {
    await Promise.all([this.loadInspectionTypes(), this.loadSystemTypes(), this.load()]);
  },

  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),
    async load() {
      this.loading = true;

      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        const params = {
          page: page,
          per_page: itemsPerPage === -1 ? this.meta.total : itemsPerPage,
          sort_field: "",
          sort_direction: "",
          search: this.search,
          "filters[type]": this.filters.type,
          "filters[system]": this.filters.system,
          "filters[date]": this.filters.date,
        };
        /*if (sortBy.length === 1 && sortDesc.length === 1) {
          params.sort_field = sortBy[0];
          params.sort_direction = sortDesc[0] ? "desc" : "asc";
        }*/
        const response = await this.$http.get(`v1/customers/${this.customerId}/inspections`, {
          params,
        });
        this.items = response.data.data;
        this.meta.total = response.data.meta.total;
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.items = [];
        this.meta.total = 0;
      }

      this.loading = false;
    },

    async loadSystemTypes() {
      try {
        const response = await this.$http.get(`v1/inspections/systems`);
        this.systemTypes = [{ text: "Все", value: "" }, ...response.data.data.map(item => ({ text: item.name, value: item.id }))];
      } catch (e) {
        // TODO: обработать ошибку
        console.error(e);
      }
    },

    async loadInspectionTypes() {
      try {
        const response = await this.$http.get(`v1/inspections/types`);
        this.inspectionTypes = [
          { text: "Все", value: "" },
          ...response.data.data.map(item => ({ text: item.name, value: item.id })),
        ];
      } catch (e) {
        // TODO: обработать ошибку
        console.error(e);
      }
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    /**
     * @param {CustomerDocumentItem} item
     * @return {Promise<void>}
     */
    async showItem(item) {
      if (this.loading) {
        return;
      }

      try {
        const r = await CustomerService.getDocument(this.customerId, item.id);

        const isUpdated = await this.$dialog.showAndWait(AddDocument, {
          customerForm: r,
          readonly:
            r.doctor_sign ||
            (this.doctorId !== r.author.id && !this.$featureFlags.feature(FLAGS.DISABLE_CHECK_DOCUMENT_AUTHOR).enabled),
          width: 600,
          doctorId: this.doctorId,
          persistent: true,
        });

        if (isUpdated) {
          this.load();
        }
      } catch (e) {
        if (e?.response.status === 404) {
          this.$dialog.notify.error(`Документ №${item.id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }

      this.$refs.tableLoader.hide();
    },
  },
};
</script>

<style scoped></style>
